import { MessageDeliveryStatusOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfMessageReport } from "components/table/columnComponents/StatusOfMessageReport"

export const customerDashboardMessagesHistoryHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Title",
    type: "sort-search",
    name: "title",
  },
  {
    title: "Message",
    type: "default",
    cellComponent: "markdown",
    name: "body",
  },
  {
    title: "Creation date",
    type: "sort-date-range",
    name: "creation_date",
    cellComponent: "datetime",
  },
  {
    title: "Delivery Date",
    type: "sort-date-range",
    name: "delivered_date",
    cellComponent: "datetime",
  },
  {
    title: "Status",
    type: "select",
    size: "small",
    name: "delivery_status",
    options: MessageDeliveryStatusOptions,
    cellComponent: StatusOfMessageReport,
  },
]
